<template>
  <div class="report-screen">
    <div class="top-panel global-offset">
      <div class="report">
        <div class="arrow"></div>
        <div class="info">
          <p>Preview Report</p>

          <div class="breadcrumbs-sc">
            <span>Home</span> <i class="glyphicon glyphicon-menu-right"></i>
            <span>Reports</span> <i class="glyphicon glyphicon-menu-right"></i>
            Preview Report
          </div>
        </div>
      </div>
    </div>
    <div class="report-filter-cont">
      <div class="filter-body">
        <div class="col-1">
          <div>
            <div class="label-3">
              Monitoring Plan:
            </div>
            <select disabled>
              <option value="" selected>Monitoring FS</option>
            </select>
          </div>
          <div>
            <div class="label-3">
              Item:
            </div>
            <select disabled>
              <option value="" selected>\\fileserver1\Shared {Windows file sharing)</option>
            </select>
          </div>
          <div>
            <div class="label-3">
              Including Subfolders:
            </div>
            <select disabled>
              <option value="" selected>One Level</option>
            </select>
          </div>
          <div>
            <div class="label-3">
              User or Group (Domain\Account):
            </div>

            <input type="text" value="%" disabled>
          </div>
          <div>
            <div class="label-3">
              Expand Group Membership:
            </div>
            <select :disabled="isSelectGroupMembership" @change="$event.target.value === 'no' ? $root.$emit(EVENT_NEXT_STEP) : ''" v-model="egm">
              <option value="no">No</option>
              <option value="yes" selected>Yes</option>
            </select>
          </div>
          <div>
            <div class="label-3">
              Permissions Type:
            </div>
            <select disabled>
              <option value="">Basic</option>
            </select>
          </div>
        </div>
        <div class="col-2">
          <div>
            <div class="label-4">
              Snapshot Date:
            </div>
            <select disabled>
              <option value="">Current Session</option>
            </select>
          </div>
          <div>
            <div class="label-4">
              Object UNC Path:
            </div>
            <div class="input-cont">
              <Autocomplete
                  :list="['\\\\fileserver1\\Shared\\Finance']"
                  :classList="['tb-input']"
                  v-model="unc"
                  :disable="isUNCDisabled"
              />
            </div>
            <div class="remove"></div>
          </div>
          <div>
            <div class="label-4">
              Object Type:
            </div>
            <select disabled>
              <option value="">Folders</option>
            </select>
          </div>
          <div>
            <div class="label-4">
              Account Type:
            </div>
            <select disabled>
              <option value="">Group, Users and Computers</option>
            </select>
          </div>
          <div>
            <div class="label-4">
              Objects with Inherited Permissions:
            </div>
            <select disabled>
              <option value="">Hide</option>
            </select>
          </div>
          <div>
            <div class="label-4">
              Effective Access:
            </div>
            <select disabled>
              <option value="">Combination of file and share permissions</option>
            </select>
          </div>
        </div>
        <div class="col-right">
          <button
              :disabled="!isViewReportClick"
              @click="isViewReportClick ? $root.$emit(EVENT_NEXT_STEP) : ''"
          >View Report
          </button>

        </div>
      </div>
      <div class="filter-expander"></div>
    </div>
    <div class="report-tools-panel">
      <div class="tool-item">
        <img src="//img.netwrix.com/elements/onlineDemo/ui_icons/back-to-start.png" alt="">
      </div>
      <div class="tool-item">
        <img src="//img.netwrix.com/elements/onlineDemo/ui_icons/back.png" alt="">
      </div>
      <div class="tool-item">
        <input type="text" value="1" class="paginator"> of 2
      </div>
      <div class="tool-item">
        <img src="//img.netwrix.com/elements/onlineDemo/ui_icons/next.png" alt="">
      </div>
      <div class="tool-item">
        <img src="//img.netwrix.com/elements/onlineDemo/ui_icons/next-to-last.png" alt="">
      </div>
      <div class="tool-item">
        <img src="//img.netwrix.com/elements/onlineDemo/ui_icons/refresh.png" alt="">
      </div>
      <div class="tool-item">
        <select name="size">
          <option value="100">100%</option>
        </select>
      </div>
      <div class="tool-item">
        <img src="//img.netwrix.com/elements/onlineDemo/ui_icons/save.png" alt="">
      </div>
      <div class="tool-item">
        <img src="//img.netwrix.com/elements/onlineDemo/ui_icons/print.png" alt="">
      </div>
      <div class="tool-item">
        <input type="text" value="" class="search">
      </div>
      <div class="tool-item">
        <span>Find</span>
        |
        <span>Next</span>
      </div>
    </div>
    <div class="report-view">
      <Loader v-show="loader"></Loader>
      <div class="report-header">
        <div class="na-logo"><img src="//img.netwrix.com/elements/onlineDemo/auditor-logo.png" alt="">Netwrix
          Auditor
        </div>
        <div class="report-date">{{ currentDate }}</div>
      </div>
      <div class="report-body">
        <h2>Folder and File Permission Details</h2>
        <p>
          Shows permissions granted on a shared folder, its subfolders and files (either directly or via group
          membership). Use this report
          to see who has access to a particular folder and its contents, and reveal objects that have permissions
          different from their parent.
          Clicking the group link opens the “Group Membership by User” report. Local file server users and groups are
          not included.
          Note: To filter out all computer accounts, set the “User of Group (Domain\Account)” filter to “%[^$]” .
        </p>
        <div class="report-result">
          <div class="report-panel report-result-filter-panel">
            <span>Filter</span>
            <span>Value</span>
          </div>
          <div class="report-source">
            <div>Object: \\fileserver1\Shared (Permissions: Different from parent)</div>
          </div>
          <div class="report-result-table">
            <div class="report-result-table-heading">
              <div class="report-panel report-col-1">Account</div>
              <div class="report-panel report-col-2">Permissions</div>
              <div class="report-panel report-col-3">Means Granted</div>
            </div>
            <div class="report-result-table-row" v-for="(row, index) in dataset1" :key="index">
              <div class="report-col-1"><b>{{ row.account }}</b></div>
              <div class="report-col-2">{{ row.permissions }}</div>
              <div class="report-col-3"><span>{{ row.means_granted }}</span></div>
            </div>
          </div>
          <div class="report-source">
            <div>\\fileserver1\Shared\Board (Permissions: Different from parent)</div>
          </div>
          <div class="report-result-table">
            <div class="report-result-table-heading">
              <div class="report-panel report-col-1">Account</div>
              <div class="report-panel report-col-2">Permissions</div>
              <div class="report-panel report-col-3">Means Granted</div>
            </div>
            <div class="report-result-table-row" v-for="(row, index) in dataset2" :key="index">
              <div class="report-col-1"><b>{{ row.account }}</b></div>
              <div class="report-col-2">{{ row.permissions }}</div>
              <div class="report-col-3"><span>{{ row.means_granted }}</span></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="line"></div>

    <div class="bottom-block global-offset">
      <div class="btn blue">Refresh
      </div>
      <div class="btn white" @click="isSubscribeStep ? $root.$emit(EVENT_NEXT_STEP) : ''">Subscribe</div>
    </div>
  </div>
</template>

<script>
  import moment from 'moment';
  import Autocomplete from '@/components/utils/Autocomplete';
  import Loader from '@/components/utils/Loader';
  import spacers from '@/mixins/spacers';

  import { EVENT_NEXT_STEP } from '@/constants';

  export default {
    name: 'preview-report-screen-sc3-st3_4',
    mixins: [spacers],
    components: {
      Autocomplete,
      Loader,
    },
    data() {
      return {
        currentLeftSpacer: 'spacer-preview-report-six-rows',
        currentRightSpacer: 'spacer-preview-report-six-rows',
        EVENT_NEXT_STEP: EVENT_NEXT_STEP,
        loader: false,
        unc: '',
        egm: 'yes',
        dataset1: [],
        dataset2: [],
      };
    },
    computed: {
      currentDate() {
        return moment().format('dddd, MMMM Do YYYY, h:mm:ss A');
      },
      fromDate() {
        return moment().subtract(1, 'days').format('L LTS');
      },
      toDate() {
        return moment().format('L LTS');
      },
      currentStep() {
        return this.$store.state.guide.currentStep;
      },
      isUNCDisabled() {
        return this.currentStep != 7;
      },
      isSelectGroupMembership() {
        return this.currentStep != 8;
      },
      isViewReportClick() {
        return this.currentStep == 9;
      },
    },
    watch: {
      unc(val) {
        if (this.currentStep == 7 && val.toLowerCase() == '\\\\fileserver1\\shared\\finance') this.$root.$emit(EVENT_NEXT_STEP);
      },
      currentStep() {
        this.updateInputs();
      },
    },
    methods: {
      updateInputs() {
        switch (this.currentStep) {
          case 5:
          case 6:
          case 7:
            this.unc = '\\\\fileserver1\\Shared';
            break;
          case 8:
            this.unc = '\\\\fileserver1\\Shared\\Finance';
            this.egm = 'yes';
            break;
          case 9:
          case 10:
            this.egm = 'no';
            this.unc = '\\\\fileserver1\\Shared\\Finance';
            break;
        }
      },
    },
    mounted() {
      this.updateInputs();

      this.loader = true;
      setTimeout(() => {
        this.loader = false;
        this.dataset1 = [
          {
            account: 'ENTERPRISE\\A.Barry',
            permissions: 'Modify (Read, Write, Execute, List folder content)',
            means_granted: 'Group',
          },
          {
            account: 'ENTERPRISE\\A.Stimpson',
            permissions: 'Modify (Read, Write, Execute, List folder content)',
            means_granted: 'Group',
          },
          {
            account: 'ENTERPRISE\\B.Connor',
            permissions: 'Modify (Read, Write, Execute, List folder content)',
            means_granted: 'Group',
          },
          {
            account: 'ENTERPRISE\\C.Dempsey',
            permissions: 'Modify (Read, Write, Execute, List folder content)',
            means_granted: 'Group',
          },
          {
            account: 'ENTERPRISE\\F.Oliver',
            permissions: 'Modify (Read, Write, Execute, List folder content)',
            means_granted: 'Group',
          },
          {
            account: 'ENTERPRISE\\M.Peterson',
            permissions: 'Modify (Read, Write, Execute, List folder content)',
            means_granted: 'Group',
          },
          {
            account: 'ENTERPRISE\\P.Jordan',
            permissions: 'Modify (Read, Write, Execute, List folder content)',
            means_granted: 'Group',
          },
          {
            account: 'ENTERPRISE\\U.King',
            permissions: 'Full Control',
            means_granted: 'Directly',
          },
        ];
        this.dataset2 = [
          {
            account: 'ENTERPRISE\\A.Barry',
            permissions: 'Modify (Read, Write, Execute, List folder content)',
            means_granted: 'Group',
          },
          {
            account: 'ENTERPRISE\\A.Stimpson',
            permissions: 'Modify (Read, Write, Execute, List folder content)',
            means_granted: 'Group',
          },
          {
            account: 'ENTERPRISE\\C.Isak',
            permissions: 'Write and List folder content',
            means_granted: 'Directly',
          },
          {
            account: 'ENTERPRISE\\H.Brooke',
            permissions: 'Write and List folder content',
            means_granted: 'Directly',
          },
          {
            account: 'ENTERPRISE\\M.Peterson',
            permissions: 'Modify (Read, Write, Execute, List folder content)',
            means_granted: 'Group',
          },
          {
            account: 'ENTERPRISE\\P.Jordan',
            permissions: 'Modify (Read, Write, Execute, List folder content)',
            means_granted: 'Group',
          },
          {
            account: 'ENTERPRISE\\U.King',
            permissions: 'Full Control',
            means_granted: 'Directly',
          },
        ];
      }, Math.floor(Math.random() * 1000) + 1000);
    },
  };
</script>

<style lang="less" scoped>
  @borderColor: #d5d5d5;

  .line {
    border-bottom: 1px solid @borderColor;
  }

  .report-screen {

    .loader {
      position: absolute;
      width: 870px;
      height: 100%;
      background: rgba(255, 255, 255, 0.75);
      z-index: 10;
    }

    .top-panel {
      margin-bottom: 5px;
      text-align: center;
      position: relative;

      .report {
        text-align: left;

        .arrow,
        .info {
          display: inline-block;
          vertical-align: top;
        }

        .arrow {
          width: 26px;
          height: 26px;
          background: url(//img.netwrix.com/elements/onlineDemo/ui_icons/arrow_back_ico.svg) 0 8px no-repeat;
          margin-right: 12px;
        }

        .info {
          p {
            font-size: 22px;
            margin-bottom: 0;
            color: #202020;
          }

          .breadcrumbs-sc {
            color: #58595b;
            font-size: 13px;
            font-weight: 400;
            line-height: 26px;

            .glyphicon {
              font-size: 12px;
            }

            span {
              color: #0d71b9;
            }
          }
        }
      }

    }

    .report-filter-cont {
      position: relative;
      .filter-body {
        background: #f7f9fb;
        border-top: 1px solid #d5d5d5;
        white-space: nowrap;

        .col-1, .col-2 {
          display: inline-block;
          vertical-align: top;
          width: auto;
          white-space: normal;

          & > div {
            margin-bottom: 18px;
          }
        }

        .col-2 {
          margin-left: 35px;
        }

        .col-right {
          white-space: normal;
          display: inline-block;
          vertical-align: top;
          color: #202020;
          font-size: 13px;
          font-weight: 400;
          line-height: 20px;
          border-left: 1px solid #d5d5d5;
          height: 250px;
          padding: 15px;
          position: absolute;
          top: 25px;
          right: 20px;

          .button-wrapper {
            padding: 5px;

            &.red-outline {
              outline: 2px solid #da262e;
            }
          }
        }

        .label-1, .label-2, .label-3, .label-4 {
          display: inline-block;
          width: 100px;
          color: #202020;
          font-size: 13px;
          font-weight: 400;
          line-height: 26px;
        }

        .label-2 {
          width: 40px;
        }

        .label-3 {
          width: 205px;
        }

        .label-4 {
          width: 215px;
        }

        .input-cont {
          display: inline-block;
        }

        input, select {
          display: inline-block;
          color: #202020;
          font-size: 13px;
          font-weight: 400;
          line-height: 26px;
          width: 231px;
          height: 23px;
          padding-left: 5px;
          border-radius: 0;
          box-shadow: none;
          background: #fff;
          border: 1px solid #ccc;
        }

        select {
          width: 231px;
        }
      }

      .filter-expander {
        height: 8px;
        background: #dedfde;
        border-top: 1px solid #a5a5a5;
      }
    }

    .report-tools-panel {
      border-bottom: 1px solid #dedfde;

      .tool-item {
        padding: 12px 6px;
        display: inline-block;

        input {
          height: 23px;
          border: 1px solid #c1c0bf;

          &.paginator {
            width: 46px;
          }

          .search {

          }
        }
      }
    }

    .report-view {
      position: relative;
      width: 870px;
      height: 1002px;

      .report {
        &-header {
          width: 870px;
          background: #1472bb;
          color: #fff;
          font-size: 14px;
          font-weight: 700;
          line-height: 26px;
          padding: 5px 40px;
          white-space: nowrap;

          .na-logo {
            width: 50%;
            display: inline-block;
            text-align: left;

            img {
              margin-right: 10px;
              vertical-align: middle;
            }
          }

          .report-date {
            width: 50%;
            display: inline-block;
            text-align: right;
          }
        }

        &-body {
          padding: 0 40px;
          width: 870px;

          h2 {
            color: #202020;
            font-size: 25px;
            font-weight: 400;
            line-height: 26px;
            margin: 15px 0 5px;
          }

          p {
            color: #202020;
            font-size: 13px;
            font-weight: 400;
            line-height: 20px;
            margin-bottom: 17px;
          }

          .report-result {
            .report-panel {
              background: #d7effe;
              height: 22px;
              color: #202020;
              font-size: 12px;
              font-weight: 600;
              line-height: 22px;
              display: inline-block;
            }

            .report-result-filter-panel {
              width: 100%;

              span {
                &:nth-child(1) {
                  margin-left: 40px;
                }

                &:nth-child(2) {
                  margin-left: 140px;
                }
              }
            }

            .report-date {
              color: #202020;
              font-size: 18px;
              font-weight: 600;
              line-height: 26px;
              margin: 15px 0 5px;
            }

            .report-source {
              color: #202020;
              font-size: 15px;
              font-weight: 600;
              line-height: 26px;
              margin-bottom: 15px;
            }

            .report-date, .report-source {
              & > div {
                display: inline-block;
                margin-top: 30px;
              }
            }

            .report-result-table {

              .report-result-table-row {
                color: #202020;
                font-size: 12px;
                font-weight: 400;
                line-height: 20px;
                border-bottom: 1px solid #dedfde;
                padding: 10px 0;

                .report-row-details {
                  padding-left: 37px;
                }

                & > div {
                  display: inline-block;
                  vertical-align: top;

                  &:first-child {

                    &.added, &.enable {
                      position: relative;

                      &:before {
                        position: absolute;
                        top: 5px;
                        left: 21px;
                        content: '';
                        width: 8px;
                        height: 8px;
                        background-color: #5aba5a;
                      }
                    }

                    &.modified {
                      position: relative;

                      &:before {
                        position: absolute;
                        top: 5px;
                        left: 21px;
                        content: '';
                        width: 8px;
                        height: 8px;
                        background-color: #f9b800;
                      }
                    }

                    &.removed, &.disable {
                      position: relative;

                      &:before {
                        position: absolute;
                        top: 5px;
                        left: 21px;
                        content: '';
                        width: 8px;
                        height: 8px;
                        background-color: #ed2b2f;
                      }
                    }
                  }
                }
              }

              .report-col-1 {
                padding-left: 37px;
                width: 310px;
              }

              .report-col-2 {
                width: 288px;
                padding-left: 5px;
              }

              .report-col-3 {
                width: 184px;
                padding-left: 5px;

                span {
                  color: #0414fb;
                }
              }
            }
          }
        }

        &-graphs {
          &-info {
            color: #202020;
            font-size: 11px;
            font-weight: 400;
            line-height: 20px;
            margin-bottom: 5px;

            & > div {
              display: inline-block;
              margin-left: 48px;

              &:first-child {
                margin-left: 0;
              }
            }
          }

          .graph-cont {
            position: relative;
            width: 390px;
            height: 215px;
            display: inline-block;
            vertical-align: top;
            margin: 0 1px 8px 1px;

            .graph-spike {
              position: absolute;
              /*border: 1px solid #000;*/
              width: 10px;
              height: 10px;
              border-radius: 50%;
              cursor: pointer;
              top: 59px;
              left: 233px;
            }

            img {
              display: block;
              border: 1px solid #c1c0bf;
            }
          }
        }
      }
    }

    .bottom-block {
      padding-top: 9px;

      .btn {
        border-radius: 0;
        min-width: 100px;
        padding: 4px 0;

        margin-right: 6px;

        &.blue {
          background-color: #1472bb;
          color: #ffffff;
        }

        &.white {
          color: #1472bb;
          border: 1px solid #1472bb;
        }
      }
    }
  }
</style>